import {Alert} from 'src/design/atoms/Alert';
import {IconCheck, IconPencil, IconRefresh} from '@tabler/icons-react';
import React from 'react';
import {ModuleEnum, TaskDefinitionStateEnum} from 'src/api/ProactApiClient';
import {TaskDefinitionStateEnumPill} from 'src/shared/constants/PillConstants';
import {useTaskPermissions} from 'src/shared/auth/permissions/useTaskPermissions';

export interface TaskStateBannerProps {
  module: ModuleEnum;
  state: TaskDefinitionStateEnum;
}

export const TaskStateBanner: React.FC<TaskStateBannerProps> = ({
  module,
  state,
}) => {
  const taskPerms = useTaskPermissions(module);
  const isAction = module === ModuleEnum.Actions;

  const pill = TaskDefinitionStateEnumPill(
    state ?? TaskDefinitionStateEnum.Draft
  );
  const title = pill.text;
  const color = pill.color;
  let icon = undefined;
  let text = undefined;
  switch (state) {
    case TaskDefinitionStateEnum.Draft:
      icon = <IconPencil />;
      text =
        'Action required! This item will not be visible to the assigned users until it has been issued. The item cannot be edited while it is issued. ';

      if (taskPerms.transitionCreate || isAction) {
        text +=
          'When ready, use the "Issue to personnel" button in "Manage Action" to issue the item.';
      } else {
        text +=
          'You do not have permissions to issue this item. Contact your administrator to request permissions or issue this item on your behalf.';
      }
      break;

    case TaskDefinitionStateEnum.Published:
      icon = <IconRefresh />;
      text =
        'This item has been assigned to user(s). To make changes, use the "Return to draft" button in "Manage Action" to return the item to an editable state. ';

      if (taskPerms.transitionCreate || isAction) {
        text +=
          'To complete this item for all users, use the "Complete" button in "Manage Action."';
      }
      break;
    case TaskDefinitionStateEnum.Completed:
      icon = <IconCheck />;
      text =
        'All required actions to complete the item have been taken and no further action is required from the assigned users for this item.';
      break;
    default:
      break;
  }

  return (
    state && (
      <Alert icon={icon} title={title} color={color} variant="light">
        {text}
      </Alert>
    )
  );
};
